import { render, staticRenderFns } from "./PickupPointsList.vue?vue&type=template&id=98902716&scoped=true&"
import script from "./PickupPointsList.vue?vue&type=script&lang=js&"
export * from "./PickupPointsList.vue?vue&type=script&lang=js&"
import style0 from "./PickupPointsList.vue?vue&type=style&index=0&id=98902716&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98902716",
  null
  
)

export default component.exports